export const baseTheme = {
  fontSizes: {
    "2xs": "0.5rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem", // 16px
    lg: "1.125rem",
    xl: "1.25rem",
    "1.5xl": "1.375rem",
    "2xl": "1.5rem",
    "2.5xl": "1.75rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  components: {
    Button: {
      variants: {
        primary: {
          width: "max-content",
          border: "2px",
          fontSize: { base: "xs", md: "md" },
          borderColor: "primary.500",
          rounded: "3xl",
          color: "white",
          bg: "primary.500",
          _hover: {
            _disabled: {
              bgColor: "primary.500"
            }
          }
        }
      }
    }
  }
};
